import { render, staticRenderFns } from "./PublicQuestionnaire.vue?vue&type=template&id=e163a988&scoped=true"
import script from "./PublicQuestionnaire.vue?vue&type=script&lang=js"
export * from "./PublicQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./PublicQuestionnaire.vue?vue&type=style&index=0&id=e163a988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e163a988",
  null
  
)

export default component.exports